<template>
  <DndProvider :backend="HTML5Backend">
    <a-config-provider>
      <router-view />
    </a-config-provider>
  </DndProvider>
</template>

<script setup lang="ts">
import { DndProvider } from 'vue3-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
// import { useWatermark } from '@hungry-studio/material';
import { useWatermark } from '@/hooks/useWatermark';

import { ref, watch } from 'vue';

import useUserStore from '@/store/modules/user';
import { storeToRefs } from 'pinia';

const userStore = useUserStore();
const { userInfo } = storeToRefs(userStore);

const watermarkConfig = ref({
  text: [] as string[],
  fontSize: 10,
  fontColor: 'rgba(0,0,0,0.05)',
  fullscreen: true,
  gap: 500,
  scale: 0.4
});

useWatermark(watermarkConfig);

watch(userInfo, () => {
  watermarkConfig.value.text = [
    `${userInfo.value.fullName}`,
    `${userInfo.value.account}@hungrystudio.com`,
    `${new Date().toLocaleDateString()}`
  ];
});
</script>
